<body>

            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3"> 

                    <div class="row justify-content-center">
                        <h6>Sales Report</h6> 
                    </div>
      
                    <!-- Tabele row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
                     <div class="card-body">

                       <div class="row pb-2">
                        <div class="col-4 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="fromDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="From Date">
                              </div>
                          </div>
                        <div class="col-4 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                              </div>
                        </div>
                        <div class="col-4 input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-vcard"></i></span>
                          </div>
                          <select [ngClass]="{'dark-input-field' : isDark }"[(ngModel)]="vehicle" class="form-control">        
                            <option [ngValue]="null">-Vehicle-</option>
                            <option *ngFor="let item of vehicleList" [value]="item.VehicleNo">
                              {{item.VehicleNo}}
                            </option>
                        </select>
                        </div>
                        </div>

                        <div class="row pb-2">
                            <div class="col-4 input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-credit-card"></i></span>
                              </div>
                              <select [ngClass]="{'dark-input-field' : isDark }"[(ngModel)]="vehicleType" class="form-control">        
                                <option [ngValue]="null">-Vehicle Type-</option>
                                <option *ngFor="let item of VEHICLE_TYPE" [value]="item.value">
                                  {{item.value}}
                                </option>
                            </select>
                            </div>

                            <div class="col-5  input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fas fa-user"></i></span>
                              </div>
                              <input [ngClass]="{'dark-input-field' : isDark }" type="text" [formControl]="myControl"  [(ngModel)]="cusName"  [matAutocomplete]="autoCustomer" class="form-control"  placeholder="Customer Name">
                              <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                                <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.CusName">
                                  {{option.CusName}}
                                </mat-option>
                              </mat-autocomplete> 
                            </div>

                            <div class="col-3 input-group">
                              <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                              <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                            </div>
                        </div>

                      <div class="col-12 table-responsive mt-2 scrollable" id="salesReport">
                        <table class="table" [ngClass]="{'dark-bg' : isDark }">
                          <thead>
                          <tr >                          
                            <th>InvoiceDate</th>
                            <th>InvoiceNo</th>
                            <th>Customer</th>                        
                            <th>Vehicle</th>                         
                            <th>VehicleType</th>
                            <th>CreatedBy</th>
                            <th class="text-right">Amount</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let item of filteredInvoiceList">    
                            <td>{{item.InvoiceDate | date :'y-MM-dd'}}</td>
                            <td>{{item.InvoiceNo}}</td>
                            <td>{{item.CusName}}</td>   
                            <td>{{item.Vehicle}}</td>
                            <td>{{item.VehicleType}}</td>  
                            <td>{{item.CreatedBy}}</td> 
                            <td class="text-right">{{item.GrandTotal |  number:'1.2-2'}}</td>                                                                                  
                          </tr>  
                          <tr class="table-active">
                            <td colspan="6" class="text-right text-bold">Total Sales :</td>
                            <td class="text-right text-bold">{{getTotalSales() | number:'1.2-2'}}</td>
                          </tr>                                              
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
      
                    <!-- this row will not appear when printing -->
                    <div class="row no-print">
                      <div class="col-12">
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
                      </div>
                    </div>


                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->         
 </body>





